import { ApolloLink } from "@apollo/client";
import {
  type ArgumentNode,
  type DocumentNode,
  type FieldNode,
  Kind,
} from "graphql";

const variableArgument = (name: string, variable: string): ArgumentNode => ({
  kind: Kind.ARGUMENT,
  name: { kind: Kind.NAME, value: name },
  value: { kind: Kind.VARIABLE, name: { kind: Kind.NAME, value: variable } },
});

const caseRowsField = (field: FieldNode): FieldNode => ({
  ...field,
  alias: { kind: Kind.NAME, value: "issue__Issue" },
  name: { kind: Kind.NAME, value: "caseRows" },
  arguments: [
    variableArgument("issueId", "id"),
    variableArgument(
      "benefitsSummarySchemaVersion",
      "benefitsSummarySchemaVersion",
    ),
  ],
});

/**
 * GetIssue with its case read answered by `caseRows`, aliased back to
 * `issue__Issue`. Apollo writes the response with the document the caller
 * watched, so GetIssue's cache entry and every reader of it are unchanged.
 */
export const viaCaseRows = (document: DocumentNode): DocumentNode => ({
  ...document,
  definitions: document.definitions.map(definition =>
    definition.kind === Kind.OPERATION_DEFINITION
      ? {
          ...definition,
          selectionSet: {
            ...definition.selectionSet,
            selections: definition.selectionSet.selections.map(selection =>
              selection.kind === Kind.FIELD &&
              selection.name.value === "issue__Issue"
                ? caseRowsField(selection)
                : selection,
            ),
          },
        }
      : definition,
  ),
});

const rewritten = new WeakMap<DocumentNode, DocumentNode>();

export const caseRowsLink = new ApolloLink((operation, forward) => {
  if (operation.operationName === "GetIssue") {
    const document =
      rewritten.get(operation.query) ?? viaCaseRows(operation.query);
    rewritten.set(operation.query, document);
    operation.query = document;
  }
  return forward(operation);
});
